import { getCookie } from '../../../helpers/cookieMetods';
import type { ShopItem } from '../../types/shop';
import { apiUrl, parseJsonOrThrow } from '../http';

export interface GetShopListArgs {
  userID?: string | { id?: string };
  all?: number;
  categoryID?: number;
  limit?: number;
}

export const getShopList = ({
  userID,
  all = 0,
  categoryID = 5,
  limit = 100,
}: GetShopListArgs = {}): Promise<ShopItem[]> => {
  const token = getCookie('_form_token');
  const resolvedUserID =
    typeof userID === 'object' && userID !== null && 'id' in userID
      ? userID.id
      : userID;
  return fetch(apiUrl('/php/newsout.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userID: resolvedUserID,
      categoryID,
      all,
      token,
      limit,
    }),
  }).then((response) =>
    parseJsonOrThrow<unknown>(response).then((raw) =>
      Array.isArray(raw) ? (raw as ShopItem[]) : []
    )
  );
};

export const getShopItemById = ({
  postID,
  categoryID,
  debug = 0,
}: {
  postID: string | number;
  categoryID?: number;
  debug?: number;
}): Promise<ShopItem | null> => {
  const token = getCookie('_form_token');
  return fetch(apiUrl('/php/newsout.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: postID,
      token,
      debug,
      categoryID,
    }),
  }).then((response) =>
    parseJsonOrThrow<unknown>(response).then((raw) => {
      if (Array.isArray(raw)) return (raw[0] as ShopItem) ?? null;
      if (raw != null && typeof raw === 'object') return raw as ShopItem;
      return null;
    })
  );
};
